import { fetchAdminUsers } from 'actions/adminUsers'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import { useEffect } from 'react'

export const useAdminUser = (userId) => {
    const dispatch = useAppDispatch()
    const { entities, isFetching } = useAppSelector((state) => state.adminUsers)
    const { adminUsers } = entities
    const user = adminUsers && adminUsers[userId]

    useEffect(() => {
        dispatch(fetchAdminUsers())
    }, [dispatch])

    return {
        user,
        isFetching,
    }
}
